import useUser from '@hooks/auth/useUser';
import useProjectId from '@hooks/useProjectId';
import Clarity from '@microsoft/clarity';
import { ReactNode, useEffect } from 'react';

interface Props {
    children: ReactNode;
}

const isDev = import.meta.env.MODE === 'development';

function ClarityProvider({ children }:Props) {
    const { user } = useUser();
    const projectId = useProjectId();
    useEffect(() => {
        if (!isDev) {
            Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID);
            Clarity.setTag('env', import.meta.env.MODE);
            Clarity.setTag('projectId', projectId);
        }
    }, [projectId]);

    useEffect(() => {
        if (user && !isDev) {
            Clarity.identify(user.barcodeNo);
        }
    }, [user]);
    return children;
}

export default ClarityProvider;
